export const flixUi = {
  bg: '#000000',
  text: '#ffffff',
  textMuted: '#a8adb8',
  textSubtle: '#777d88',
  borderSubtle: 'rgba(255,255,255,0.24)',
  borderStrong: 'rgba(255,255,255,0.55)',
  primary: '#e50914',
  fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  headingWeight: 700,
  titleLetterSpacing: -0.7,
  buttonRadius: 8,
};

export const flixButton = {
  minWidth: 150,
  padding: '0.75rem 1.05rem',
  borderRadius: flixUi.buttonRadius,
  fontWeight: 700,
  fontFamily: flixUi.fontFamily,
};
